import React from 'react'

function TermDepositEnquiry(props) {
  debugger
    console.log(props.termDeposit)
    // props.termDeposit.BODY.AccountEnquiryDetails_Response.Body.Payload.Account_Branch
    // props.termDeposit.BODY.AccountEnquiryDetails_Response.Body.Payload["A/c_Opening_Date"]
    let Account_number= props.termDeposit.BODY.AccountEnquiryDetails_Response.Body.Payload.Account_Number
    let Account_name= props.termDeposit.BODY.AccountEnquiryDetails_Response.Body.Payload.Account_Name
    let Account_desc= props.termDeposit.BODY.AccountEnquiryDetails_Response.Body.Payload.Account_Description
    let Principal_amount= (props.termDeposit.BODY.AccountEnquiryDetails_Response.Body.Payload.Curr_Bal).replace(/\+$/, '')
    let Interest_rate= props.termDeposit.BODY.AccountEnquiryDetails_Response.Body.Payload.Int_Rate
    let Interest_Accrued= (props.termDeposit.BODY.AccountEnquiryDetails_Response.Body.Payload.Interest_Accrued).replace(/\+$/, '')
    let Maturity_Amount= (props.termDeposit.BODY.AccountEnquiryDetails_Response.Body.Payload.Maturity_Amount).replace(/\+$/, '')
    let account_open=props.termDeposit.BODY.AccountEnquiryDetails_Response.Body.Payload["A/c_Opening_Date"]

    let Maturity_Date=props.termDeposit.BODY.AccountEnquiryDetails_Response.Body.Payload.Maturity_Date
    let Branch_Name=props.termDeposit.BODY.AccountEnquiryDetails_Response.Body.Payload.Branch_Name
    function formatDate(account_open) {
      // Ensure the string is exactly 8 characters long
      if (account_open.length !== 8) {
          return "Invalid date format";
      }
  
      // Extract day, month, and year
      const day = account_open.slice(0, 2);
      const month = account_open.slice(2, 4);
      const year = account_open.slice(4, 8);
  
      // Format the date
      return `${day}/${month}/${year}`;
  }
  const account_opening=formatDate(account_open)
  console.log(account_opening)
  const maturity_date=formatDate(Maturity_Date)
  console.log(maturity_date)
  
 
  return (
    <div className="msg-content-wrapper message-content-wrapper-bot msg-content-wrapper-border width-70"
    style={{
          border: '8px solid rgba(244, 176, 53, 0.8)',
      backgroundColor: 'rgba(245, 243, 243, 1)',
      marginLeft: '20px',
      fontSize:"16px",
      fontWeight:"600",
      textAlign:"center"
    }}>Term Deposit Details
    <div style={{textAlign:"start"}}>

       <h6>{`Account Name : ${Account_name ||'NA'}`}</h6>
      <h6>{`Account Number :${Account_number ||'NA'}`}</h6>
     
      <h6>{`Savings Account :${Account_desc ||'NA'}`}</h6>
      <h6>{`Principal Amount :₹${Principal_amount ||'NA'}`}</h6>
      <h6>{`Interest Rate:${Interest_rate ||'NA'}%`}</h6>
      <h6>{`Interest Accrued :₹${Interest_Accrued ||'NA'}`}</h6>
      <h6>{`Maturity Amount:₹${Maturity_Amount ||'NA'}`}</h6>
      <h6>{`A/c Opening Date:${account_opening ||'NA'}`}</h6>
      <h6>{`Maturity Date :${maturity_date ||'NA'}`}</h6>
      <h6>{`Branch Name :${Branch_Name ||'NA'}`}</h6>
      </div>
    </div>
  )
}

export default TermDepositEnquiry